var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyProgram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 179,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m157,7.5c0,0 -28.6,36.3 -74.4,14.6c-45.8,-21.6 -91.6,36.9 -52.2,72.6c39.5,35.6 0.8,55.2 27.7,77c30.4,24.8 57,-25.5 81.1,-14.1c53.4,25.3 92.9,15.3 84,-13.9c-15.6,-51.4 -35.6,-54.8 -20.4,-81.5c15.3,-26.7 -18.4,-82.3 -45.8,-54.7z",
    fill: "#f1f3f3",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189,141.4l-133.7,0c-3.2,0 -5.8,-2.6 -5.8,-5.7l0,-88.4c0,-3.1 2.6,-5.8 5.8,-5.8l133.7,0c3.2,0 5.8,2.7 5.8,5.8l0,88.4c0,3.2 -2.6,5.7 -5.8,5.7z",
    fill: "#eb672d",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9,101.2l3.2,-3.2c1.2,-1.3 1.2,-3.3 0,-4.5c-1.3,-1.3 -3.3,-1.3 -4.6,0l-3.1,3.2l-3.2,-3.2c-1.3,-1.3 -3.3,-1.3 -4.5,0c-1.3,1.2 -1.3,3.3 0,4.5l3.1,3.2l-3,3c-1.2,1.2 -1.2,3.3 0,4.5c1.3,1.3 3.3,1.3 4.6,0l3,-3l3,3c1.2,1.3 3.2,1.3 4.5,0c1.2,-1.3 1.2,-3.3 0,-4.5l-3,-3z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.1,178.7c2.1,0 3.8,-1.8 3.8,-3.9c0,-2.1 -1.7,-3.8 -3.8,-3.8c-2.2,0 -3.9,1.7 -3.9,3.8c0,2.1 1.7,3.9 3.9,3.9z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.8,137.6l-3.2,-3.2c-1.2,-1.3 -1.2,-3.3 0,-4.5c1.3,-1.3 3.3,-1.3 4.6,0l3.1,3.2l3.2,-3.2c1.3,-1.3 3.3,-1.3 4.6,0c1.2,1.2 1.2,3.3 0,4.5l-3.2,3.2l3,3c1.2,1.2 1.2,3.3 0,4.5c-1.3,1.3 -3.3,1.3 -4.5,0l-3.1,-3l-3,3c-1.2,1.3 -3.2,1.3 -4.5,0c-1.2,-1.3 -1.2,-3.3 0,-4.5l3,-3z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.2,87.3c3.1,0 5.6,2.5 5.6,5.7c0,3.1 -2.5,5.6 -5.6,5.6c-3.2,0 -5.7,-2.5 -5.7,-5.6c0,-3.2 2.5,-5.7 5.7,-5.7zm0,7.7c1.1,0 2,-0.9 2,-2c0,-1.2 -0.9,-2.1 -2,-2.1c-1.2,0 -2.1,0.9 -2.1,2.1c0,1.1 0.9,2 2.1,2z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.7,39.7c-3.2,0 -5.7,2.6 -5.7,5.7c0,3.1 2.5,5.7 5.7,5.7c3.1,0 5.7,-2.5 5.7,-5.7c0,-3.1 -2.6,-5.7 -5.7,-5.7zm0,7.8c-1.1,0 -2.1,-0.9 -2.1,-2.1c0,-1.1 0.9,-2 2.1,-2c1.1,0 2,0.9 2,2c0,1.2 -0.9,2.1 -2,2.1z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.4,3.5c-1.9,0 -3.4,1.5 -3.4,3.3l0,22.6c0,1.8 1.5,3.4 3.4,3.4c1.8,0 3.3,-1.6 3.3,-3.4l0,-22.6c0,-1.8 -1.5,-3.3 -3.3,-3.3z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.2,47.6c0,-1.9 -1.6,-3.4 -3.4,-3.4l-22.6,0c-1.8,0 -3.3,1.5 -3.3,3.4c0,1.8 1.5,3.3 3.3,3.3l22.6,0c1.8,0 3.4,-1.4 3.4,-3.3z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.4,15.7c-1.4,-1.3 -3.5,-1.2 -4.8,0.1l-15.6,16.1c-1.3,1.4 -1.3,3.5 0,4.8c1.4,1.3 3.5,1.3 4.8,-0.1l15.6,-16.1c1.3,-1.4 1.3,-3.5 0,-4.8z",
    fill: "rgba(235, 103, 45, 0.7)",
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.6,137.4l-132.8,0c-1.2,0 -2.2,-1 -2.2,-2.2l0,-87.4c0,-1.2 1,-2.2 2.2,-2.2l132.8,0c1.2,0 2.1,1 2.1,2.2l0,87.4c0,1.2 -0.9,2.2 -2.1,2.2z",
    fill: "#fcfdfd",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.1,111c-0.7,0 -1.3,-0.2 -1.8,-0.6c-1.3,-1.1 -3.1,-1.7 -4.9,-1.7c0,0 0,0 -0.1,0c-1.8,0 -3.6,0.6 -4.9,1.6c-1.2,1 -2.9,0.8 -3.9,-0.3c-1,-1.2 -0.8,-2.9 0.3,-3.9c2.3,-2 5.3,-3 8.5,-3l0.1,0c3.2,0 6.2,1.1 8.5,3c1.1,1 1.3,2.8 0.3,4c-0.5,0.6 -1.3,0.9 -2.1,0.9z",
    fill: "#eb672d",
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.7,62.6l-137.1,0l0,-14.8c0,-1.2 1,-2.2 2.2,-2.2l132.8,0c1.2,0 2.1,1 2.1,2.2l0,14.8z",
    fill: "#eb672d",
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.8,56.9c-1.5,0 -2.8,-1.3 -2.8,-2.8c0,-1.6 1.2,-2.8 2.8,-2.8l0,0c1.6,0 2.8,1.3 2.8,2.8c0,1.6 -1.2,2.8 -2.8,2.8z",
    fill: "#d3dbdc",
    id: "svg_14",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71,56.9c-1.5,0 -2.8,-1.3 -2.8,-2.8c0,-1.6 1.3,-2.8 2.8,-2.8l0,0c1.6,0 2.8,1.3 2.8,2.8c0,1.6 -1.2,2.8 -2.8,2.8z",
    fill: "#d3dbdc",
    id: "svg_15",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.3,56.9c-1.6,0 -2.9,-1.3 -2.9,-2.8c0,-1.6 1.3,-2.8 2.8,-2.8l0.1,0c1.5,0 2.8,1.3 2.8,2.8c0,1.6 -1.3,2.8 -2.8,2.8z",
    fill: "#d3dbdc",
    id: "svg_16",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.4,95.6l1.4,-1.4c0.5,-0.5 0.5,-1.3 0,-1.9c-0.5,-0.5 -1.4,-0.5 -1.9,0l-1.3,1.3l-1.4,-1.3c-0.5,-0.5 -1.3,-0.5 -1.9,0c-0.5,0.6 -0.5,1.4 0,1.9l1.4,1.4l-1.3,1.2c-0.5,0.6 -0.5,1.4 0,1.9c0.5,0.6 1.4,0.6 1.9,0l1.3,-1.2l1.2,1.2c0.5,0.6 1.4,0.6 1.9,0c0.5,-0.5 0.5,-1.3 0,-1.9l-1.3,-1.2z",
    fill: "#eb672d",
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.9,95.6l1.3,-1.4c0.5,-0.5 0.5,-1.3 0,-1.9c-0.5,-0.5 -1.4,-0.5 -1.9,0l-1.3,1.3l-1.4,-1.3c-0.5,-0.5 -1.3,-0.5 -1.8,0c-0.5,0.6 -0.5,1.4 0,1.9l1.3,1.4l-1.3,1.2c-0.5,0.6 -0.5,1.4 0,1.9c0.5,0.6 1.4,0.6 1.9,0l1.3,-1.2l1.2,1.2c0.5,0.6 1.4,0.6 1.9,0c0.5,-0.5 0.5,-1.3 0,-1.9l-1.2,-1.2z",
    fill: "#eb672d",
    id: "svg_18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProgram);
export default __webpack_public_path__ + "static/media/EmptyProgram.6947d9f71923097480be9383700fdbde.svg";
export { ForwardRef as ReactComponent };